import "./Notifications.css"
import { useNotifications } from "../../app/hooks"
import NotificationItem from "./NotificationItem"
import {
  IExtendedMessage,
  setNotifications,
  updateNotification,
} from "../../app/slices/notificationSlice"
import { useContext, useEffect, useState } from "react"
import { orderBy, take } from "lodash-es"
import { useTranslation } from "react-i18next"
import {
  Button,
  StatusInfo,
  Row,
  Col,
  ButtonGroup,
} from "@george-labs.com/design-system"
import { store } from "../../app/store"
import AuthContext from "../../providers/AuthProvider"
import Sidebar from "../../components/Sidebar/Sidebar"
import {
  GetMessagesForCustomerRq,
  MessageReadRq,
} from "@smartx/mikro-vt-client-api"
import { RequestHeader } from "../../utils/utils"
import { messageReadApi, messagesApi } from "../../api/apiClient"

const NOTIFICATION_HIDE_AFTER_LIMIT = 5

const Notifications = () => {
  const authContext = useContext(AuthContext)
  const { t } = useTranslation()

  const notifications = useNotifications()

  const [inspectNotification, setInspectNotification] = useState<string>(null)
  const [isShowingMore, setIsShowingMore] = useState(false)
  const [filteredNotifications, setFilteredNotifications] = useState(
    take(
      orderBy(notifications, ["creationDate"], ["desc"]),
      NOTIFICATION_HIDE_AFTER_LIMIT,
    ),
  )

  const showMore = () => {
    setIsShowingMore(true)
    setFilteredNotifications(orderBy(notifications, ["creationDate"], ["desc"]))
  }

  useEffect(() => {
    authContext.refresh()

    const rq: GetMessagesForCustomerRq = {
      header: new RequestHeader(),
    }
    messagesApi.getMessagesForCustomer(rq).then((res) => {
      const data = res.data.messages.map(
        (message) =>
          ({
            ...message,
            clicked: false,
            readOnInit: message.read,
          }) as IExtendedMessage,
      )

      store.dispatch(setNotifications(data ?? []))
    })
  }, [authContext])

  const readNotification = async (notification: IExtendedMessage) => {
    authContext.refresh()
    if (!notification.read) {
      const rq: MessageReadRq = {
        header: new RequestHeader(),
        messageId: notification.messageId,
      }
      await messageReadApi.messageRead(rq)
    }

    store.dispatch(
      updateNotification({
        ...notification,
        clicked: !notification.clicked,
        read: true,
      }),
    )

    setInspectNotification(notification.messageId)
  }

  return (
    <Row className="mt-2" style={{ marginBottom: "3.5rem" }}>
      <Col md={3}>
        <Sidebar />
      </Col>
      <Col md={9}>
        {notifications?.length === 0 && (
          <StatusInfo title={t("notifications.noMessages")} />
        )}

        {notifications.length > 0 && !inspectNotification && (
          <>
            {filteredNotifications.map((notification) => (
              <button
                type="button"
                onClick={() => readNotification(notification)}
                style={{
                  cursor: "pointer",
                  background: "none",
                  border: "none",
                  padding: 0,
                  width: "100%",
                  textAlign: "left",
                }}
                className="mt-2"
                key={`btn-${notification.messageId}`}
              >
                <NotificationItem
                  key={notification.messageId}
                  id={notification.messageId}
                  clamped
                />
              </button>
            ))}
          </>
        )}
        {notifications.length > NOTIFICATION_HIDE_AFTER_LIMIT &&
          !inspectNotification &&
          !isShowingMore && (
            <ButtonGroup className="text-center mt-2">
              <Button
                variant={Button.VARIANT.SECONDARY}
                onClick={() => showMore()}
              >
                {t("notifications.showMore")}
              </Button>
            </ButtonGroup>
          )}

        {inspectNotification && (
          <>
            <div className="mt-2">
              <NotificationItem
                key={inspectNotification}
                id={inspectNotification}
                clamped={false}
              />
            </div>
            <ButtonGroup className="text-center mt-2">
              <Button
                variant={Button.VARIANT.SECONDARY}
                onClick={() => setInspectNotification(null)}
              >
                {t("common.button.back")}
              </Button>
            </ButtonGroup>
          </>
        )}
      </Col>
    </Row>
  )
}

export default Notifications
